import { useState, useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import Icons from './Icons'

const marketData = [
  { name: 'BTC/USDT', price: 67432.50, change: 2.34, volume: '32.5B' },
  { name: 'ETH/USDT', price: 3521.80, change: 1.87, volume: '18.2B' },
  { name: 'SOL/USDT', price: 178.45, change: -0.52, volume: '4.8B' },
  { name: 'XRP/USDT', price: 0.6234, change: 3.21, volume: '2.1B' },
  { name: 'DOGE/USDT', price: 0.1789, change: 5.67, volume: '1.5B' },
]

export function MarketData() {
  const [activeTab, setActiveTab] = useState('hot')
  const marketRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.market-row',
        { opacity: 0, x: -20 },
        {
          opacity: 1,
          x: 0,
          duration: 0.4,
          stagger: 0.1,
          scrollTrigger: {
            trigger: marketRef.current,
            start: 'top 80%',
          },
        }
      )
    }, marketRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      ref={marketRef}
      id="market"
      className="section-padding relative overflow-hidden"
    >
      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-2">
              <span className="gradient-text">市场行情</span>
            </h2>
            <p className="text-[#8080a0]">实时追踪热门数字资产价格走势</p>
          </div>

          {/* Tabs */}
          <div className="flex gap-2 mt-4 md:mt-0">
            {['hot', 'gainers', 'losers'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer ${
                  activeTab === tab
                    ? 'bg-[#ff00ff] text-white'
                    : 'bg-[#1a1a24] text-[#8080a0] hover:text-[#e0e0ff]'
                }`}
              >
                {tab === 'hot' ? '热门' : tab === 'gainers' ? '涨幅榜' : '跌幅榜'}
              </button>
            ))}
          </div>
        </div>

        {/* Market Table */}
        <div className="cyber-border rounded-2xl overflow-hidden bg-[#13131a]">
          {/* Table Header */}
          <div className="grid grid-cols-4 gap-4 px-6 py-4 border-b border-[rgba(255,0,255,0.1)] text-[#8080a0] text-sm">
            <div>交易对</div>
            <div className="text-right">最新价格</div>
            <div className="text-right">24h涨跌</div>
            <div className="text-right hidden md:block">24h成交量</div>
          </div>

          {/* Table Body */}
          <div className="divide-y divide-[rgba(255,0,255,0.05)]">
            {marketData.map((item, index) => (
              <div
                key={index}
                className="market-row grid grid-cols-4 gap-4 px-6 py-4 hover:bg-[rgba(255,0,255,0.02)] transition-colors cursor-pointer"
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#ff00ff] to-[#00ffff] flex items-center justify-center text-xs font-bold text-white">
                    {item.name.slice(0, 1)}
                  </div>
                  <span className="text-[#e0e0ff] font-medium">{item.name}</span>
                </div>
                <div className="text-right text-[#e0e0ff] font-mono">
                  ${item.price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 })}
                </div>
                <div className={`text-right font-mono flex items-center justify-end gap-1 ${
                  item.change >= 0 ? 'text-[#00ff88]' : 'text-[#ff4757]'
                }`}>
                  {item.change >= 0 ? <Icons.TrendingUp /> : <Icons.TrendingDown />}
                  {Math.abs(item.change)}%
                </div>
                <div className="text-right text-[#8080a0] font-mono hidden md:block">
                  {item.volume}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* View All Link */}
        <div className="mt-6 text-center">
          <a
            href="https://www.jsqkmfytwpn.com/join/1p9999"
            target="_blank"
            rel="noopener"
            className="inline-flex items-center gap-2 text-[#ff00ff] hover:text-[#00ffff] transition-colors"
          >
            查看更多行情
            <Icons.ArrowRight />
          </a>
        </div>
      </div>
    </section>
  )
}
